import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import cart from './modules/cart'
import read from './modules/read'
import routerHelp from './modules/routerHelp'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    cart,
    read,
    routerHelp
  },
  getters,
})

export default store
